import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
// Import the security measures
// import './Security'; 


const dodigitals = ReactDOM.createRoot(document.getElementById('dodigitals'));
dodigitals.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
reportWebVitals();
